import React from 'react';

const paths = {
  selection: (
    <>
      <path d="M19 14h-5a4 4 0 0 0-4 4v30a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4V18a4 4 0 0 0-4-4h-5" />
      <rect x="19" y="9" width="18" height="10" rx="3" />
      <path d="m19 33 6 6 14-14M19 45h14" />
    </>
  ),
  sellsheets: (
    <>
      <path d="M17 14H9v38h31v-8M20 7h21l12 12v26H20z" />
      <path d="M40 7v13h13M28 29h16M28 36h11" />
    </>
  ),
  decisionemails: (
    <>
      <rect x="7" y="18" width="44" height="32" rx="5" />
      <path d="m8 21 21 15 21-15M37 8h19m-6-6 6 6-6 6" />
    </>
  ),
  balance: (
    <>
      <path d="M8 53h48" />
      <rect x="13" y="30" width="9" height="23" rx="2.5" />
      <rect x="27.5" y="17" width="9" height="36" rx="2.5" />
      <rect x="42" y="34" width="9" height="19" rx="2.5" />
      <path d="M8 24h48" strokeDasharray="3 4" />
      <circle cx="32" cy="10" r="2.2" />
    </>
  ),
};

export default function ProjectsChooserIcon({ name, className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 64 64"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {paths[name]}
    </svg>
  );
}

export function ProjectsChooserArrow({ className }) {
  return (
    <svg
      className={className}
      width="13"
      height="13"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      aria-hidden="true"
    >
      <path d="M6 18 18 6M6 6h12v12" />
    </svg>
  );
}

export function ProjectsChooserCloseIcon({ className }) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      aria-hidden="true"
    >
      <path d="m6 6 12 12M18 6 6 18" />
    </svg>
  );
}

export function ProjectsChooserFolderIcon({ className }) {
  return (
    <svg
      className={className}
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      aria-hidden="true"
    >
      <path d="M3 7h7l2 2h9v11H3zM3 7V4h7l2 3" />
    </svg>
  );
}
